import styled, { css } from "styled-components";

export const Container = styled.div`
  background-color: #d7f0db;
  display: flex;
  align-items: center;
  height: 80px;
  justify-content: space-between;
  padding: 20px 20px;

  .profile {
    display: none;
  }

  .logo {
    width: 100px;
    height: fit-content;
    margin-left: 65px;
    border-radius: 5px;
  }
  @media (max-width: 900px) {
    .info {
      display: none;
    }
  }

  @media (min-width: 1200px) {
    .menu {
      display: none;
    }

    .profile {
      display: flex;
      flex-direction: row;
      align-items: center;
      color: #fff;

      img {
        width: 40px;
        background-color: #fff;
        height: 40px;
        margin-right: 15px;
        border-radius: 40px;
      }
    }

    .logo {
      width: 100px;
      height: fit-content;
      margin-left: 5px;
      border-radius: 5px;
    }
  }

  img {
    width: 50px;
    border-radius: 50px;
    height: 50px;
    object-fit: scale-down;
  }

  > div {
    position: absolute;
    right: 20px;
    height: 60px;
    display: flex;
    justify-content: center;
    align-items: flex-end;

    p {
      color: #585858;
      margin-right: 10px;
      font-size: 15px;
      font-weight: 400;
      text-align: right;
      margin-bottom: 5px;
      width: 100%;
    }
  }
`;

export const Logo = styled.div`
  text-align: center;
  height: 80px;
  width: 180px;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.3s ease;
  position: absolute;
  left: 20px;

  img {
    height: 65px;
    width: 160px;
  }

  h1 {
    color: #fff;
    font-size: 30px;
  }

  @media (max-width: 1200px) {
    left: ${(props) => (props.sidebar ? "60px" : "20px")};
    height: 60px;
    width: 135px;
  }
`;
